import { Button, Flex, Typography } from "antd"

export const SettingsCallBackPayoutUi = () => {
  return (
    <Typography.Text>
      Here, you can add a Callback Payout URL to receive automatic notifications
      about payout status updates. This ensures your system stays informed in
      real time when a payout is processed, completed, or encounters an issue.
    </Typography.Text>
  )
}
